import React from "react";
import DownloadTracking from "../DownloadReport/tracking";

export default function ScoreCardTracking() {
  return <DownloadTracking apiPath="backoffice/scorecard" documentLabel="Score Card" />;
}
